import "./HideFor.scss";
import { ElementType, ReactNode } from "react";
import cn from "classnames";
interface GridCell {
  children: ReactNode;
  wrapperTag?: ElementType;
  mobile?: boolean;
  tablet?: boolean;
  desktop?: boolean;
  desktopMedium?: boolean;
  desktopLargeUp?: boolean;
  display?: "block" | "flex" | "inline" | "inline-block";
}

const HideFor = ({
  children,
  wrapperTag,
  mobile,
  tablet,
  desktop,
  desktopMedium,
  desktopLargeUp,
  display = "block",
}: GridCell) => {
  const Tag = wrapperTag;

  const classes = cn("hide-for-norad", {
    "hide-for-norad--mobile": mobile,
    "hide-for-norad--tablet": tablet,
    "hide-for-norad--desktop": desktop,
    "hide-for-norad--desktop-medium": desktopMedium,
    "hide-for-norad--desktop-large-up": desktopLargeUp,
    "hide-for-norad--display-block": display === "block",
    "hide-for-norad--display-inline": display === "inline",
    "hide-for-norad--display-inline-block": display === "inline-block",
    "hide-for-norad--display-flex": display === "flex",
  });

  return Tag ? (
    <Tag className={classes}>{children}</Tag>
  ) : (
    <div className={classes}>{children}</div>
  );
};

export default HideFor;
